import { nanoid } from "nanoid";
import { joinLines } from "../../helpers/exportHelpers";
import { IExportArtifact } from "../ExportArtifacts/IExportArtifact";
import { IModelInfo } from "../ModelInfos/IModelInfo";

export function generateTsInterface(models: IModelInfo[]): IExportArtifact[] {
    const artifacts: IExportArtifact[] = [];
    const tab = "    ";
    const line = "\r\n";

    for (const model of models) {
        const properties = model.members.map(x => `${tab}${x.name}: ${x.type.name};`);
        //const usings = model.imports.map(x => `using ${x};`)

        const fileContent = joinLines(line, [
            `export interface I${model.name}`,
            `{`,
            ...properties,
            `}`
        ]);

        const artifact: IExportArtifact = {
            id: nanoid(),
            exportId: nanoid(),
            created: new Date(),
            fileName: `I${model.name}.ts`,
            content: fileContent
        };
        artifacts.push(artifact);
    }

    return artifacts;
}
